import { useTranslation } from 'react-i18next'

const LANGUAGE_KEY = 'lang'

export const useLocalization = () => {
  const { i18n } = useTranslation()

  const setAppLanguage = (lang) => {
    localStorage.setItem(LANGUAGE_KEY, lang)
    i18n.changeLanguage(lang)
  }

  const saveAppLanguage = (lang) => localStorage.setItem(LANGUAGE_KEY, lang)

  const getCurrentLanguage = () => {
    const translationResources = i18n.options?.resources
    const hasLanguage = Object.prototype.hasOwnProperty.call(
      translationResources,
      localStorage.getItem(LANGUAGE_KEY),
    )
    const locale = hasLanguage
      ? localStorage.getItem(LANGUAGE_KEY)
      : i18n.options?.fallbackLng
    saveAppLanguage(locale)
    return locale
  }

  return { setAppLanguage, getCurrentLanguage, saveAppLanguage }
}
